"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { CollectedCollectionType, CollectionSort } from "@/entities/IProfile";
import { SortDirection } from "@/entities/ISort";
import CommonSelect, { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import { COLLECTED_COLLECTIONS_META } from "./user-page-collected-filters.helpers";
export default function UserPageCollectedFiltersSortBy(t0) {
  const $ = _c(13);
  const {
    selected,
    direction,
    collection,
    setSelected
  } = t0;
  let getItems;
  let t1;
  let t2;
  if ($[0] !== collection) {
    const labels = {
      [CollectionSort.TOKEN_ID]: "Token ID",
      [CollectionSort.TDH]: "TDH",
      [CollectionSort.RANK]: "Rank"
    };
    getItems = () => {
      const items = Object.values(CollectionSort).map(sort => ({
        label: labels[sort],
        value: sort,
        key: sort
      }));
      return items.filter(item => collection ? COLLECTED_COLLECTIONS_META[collection].filters.sort.includes(item.value) : true);
    };
    t1 = useState;
    t2 = getItems();
    $[0] = collection;
    $[1] = getItems;
    $[2] = t1;
    $[3] = t2;
  } else {
    getItems = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const [items_0, setItems] = t1(t2);
  let t3;
  if ($[4] !== getItems) {
    t3 = () => {
      setItems(getItems());
    };
    $[4] = getItems;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== collection) {
    t4 = [collection];
    $[6] = collection;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== direction || $[9] !== items_0 || $[10] !== selected || $[11] !== setSelected) {
    t5 = <CommonSelect items={items_0} activeItem={selected} filterLabel="Sort By" setSelected={setSelected} sortDirection={direction} />;
    $[8] = direction;
    $[9] = items_0;
    $[10] = selected;
    $[11] = setSelected;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}